import { render, staticRenderFns } from "./BundleBulkIndividualHeader.vue?vue&type=template&id=3d674ec8&scoped=true&lang=pug&"
import script from "./BundleBulkIndividualHeader.vue?vue&type=script&lang=js&"
export * from "./BundleBulkIndividualHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d674ec8",
  null
  
)

/* custom blocks */
import block0 from "./BundleBulkIndividualHeader.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
